
import {IBusinessObject} from '../PA.Core.IF.BO'
import {IProgressProvider} from '../PA.Core.IF.Basic'
import {ProgressProvider} from '../Basic/Progress'

export class BusinessObjectValidator //<aBO extends IBusinessObject>
{
  ValidateProgressProvider: IProgressProvider;
  private _validateOpts: any;
  private _validateBoQueue: IBusinessObject[];
  private _validatedBOs: IBusinessObject[];
  private _validateCount: number;
  private _validateExceptionCount: number;
  private _ConcurrentTaskCount: number;

  constructor(arrBOs: IBusinessObject[], validateOptions: any) {

    this.ValidateProgressProvider = new ProgressProvider("Business Object Validator");
    this._validateOpts = validateOptions || {};
    this._validateBoQueue = arrBOs.slice();
    this._validatedBOs = [];
    this._validateCount = 0;
    this._validateExceptionCount = 0;
    this._ConcurrentTaskCount = 5;
  }

  get ValidatedBOs(): IBusinessObject[] {
    return this._validatedBOs;
  }

  Validate(opts?: any): Promise<BusinessObjectValidator> {
    var self = this;
    this._validateOpts = opts || this._validateOpts || {};

    return new Promise<BusinessObjectValidator>((resolve, error) => {
      self.ValidateProgressProvider.start("Starting Validates");
      self._SubValidate(self._validateOpts).then(() => {
        self.updateProgress();
        self.ValidateProgressProvider.finish(); // Errors are expected from user input
        resolve(self);

      }).catch((err) => {
        self.updateProgress();
        self.ValidateProgressProvider.exception(err);
        resolve(self);
      });
    })
  }

  private _SubValidate(opts: any): Promise<void> {
    var self = this;
    return new Promise<void>((resolve, error) => {
      if (self._validateBoQueue.length == 0) {
        resolve();
      }

      // Dequeue X BOs and validate them
      var tasks = [];
      for (let i = 0; i < self._ConcurrentTaskCount; i++) {
        let nextBO: IBusinessObject;
        if (self._validateBoQueue.length == 0)
          break;
        else
          nextBO = self._validateBoQueue.pop();

        self._validatedBOs.push(nextBO);
        self.updateProgress();

        tasks.push(nextBO.Validate(self._validateOpts).then((aValidatedBO) => {
          self._validateCount += 1;
          self.updateProgress();
        }).catch((err) => {
          self._validateExceptionCount += 1;
          self.updateProgress();
        }));
      }
      ;

      if (tasks.length > 0) {
        return Promise.all(tasks).then((results) => {
          // if there is more, recurse.
          if (self._validateBoQueue.length > 0)
            return self._SubValidate(opts).then(() => {
              resolve();
            })
          else
            resolve();
        });
      } else {
        resolve();
      }
    })
  }

  private updateProgress() {
    var total_count = this._validateBoQueue.length + this._validatedBOs.length;
    var in_progress_count = this._validatedBOs.length - this._validateCount;
    var waiting_in_queue = total_count - this._validateBoQueue.length;
    var sStatusMessage = 'Total: ' + total_count +
      ', Validated: ' + this._validateCount +
      ', Processing/Waiting: ' + in_progress_count + '/ ' + waiting_in_queue;

    this.ValidateProgressProvider.setProgressMessage('BusinessObjectValidator.status', sStatusMessage);
    if (total_count > 0) {
      this.ValidateProgressProvider.setPercentComplete(this._validateCount / total_count);
    }
  }

}

